import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const RockstarNFT: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="RockstarNFT"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <circle
            cx="24"
            cy="24"
            r="24"
            fill="url(#paint0_linear_8581_29753)"
          />
          <path
            d="M24.0006 40.0043C25.9014 40.0043 27.5327 38.8655 28.2577 37.2341C28.4336 36.837 28.1401 36.3898 27.7058 36.3898H20.2963C19.862 36.3898 19.5667 36.836 19.7445 37.2341C20.4694 38.8655 22.1008 40.0043 24.0015 40.0043"
            fill="#FF83F3"
          />
          <path
            d="M34.5664 31.5193C33.4464 31.5193 32.539 30.6118 32.539 29.4919V22.1272C32.539 18.1361 29.7994 14.7858 26.099 13.8508C25.9631 12.7988 25.0659 11.9843 23.9761 11.9843C22.8863 11.9843 21.9822 12.8057 21.8524 13.8637C18.5313 14.7256 15.9973 17.5366 15.5414 21.003C15.5345 21.0538 15.5276 21.1037 15.5216 21.1553C15.513 21.2241 15.5061 21.292 15.501 21.3617C15.4958 21.4314 15.4898 21.5002 15.4855 21.569C15.4812 21.6275 15.4769 21.6834 15.4743 21.7419C15.4691 21.858 15.4657 21.9759 15.4657 22.0946V29.4911C15.4657 30.6058 14.5668 31.5098 13.4538 31.5184C12.9231 31.5228 12.4844 31.9322 12.4844 32.4646V32.4732C12.4844 32.9996 12.9119 33.4271 13.4383 33.4271H34.5621C35.0885 33.4271 35.516 32.9996 35.516 32.4732C35.5186 31.9477 35.0911 31.5202 34.5646 31.5202L34.5664 31.5193Z"
            fill="#FF83F3"
          />
          <path
            d="M30.5825 12.4297C33.1397 12.9778 35.0923 15.1785 35.333 17.7838C35.3598 18.0727 35.6117 18.2884 35.9061 18.2597C36.0459 18.2468 36.1727 18.1792 36.2635 18.0718C36.3524 17.9635 36.3959 17.8264 36.3829 17.6866C36.2413 16.1655 35.6283 14.7591 34.609 13.6157C33.597 12.4834 32.2814 11.7167 30.8028 11.3992C30.7658 11.3918 30.7287 11.3871 30.6926 11.3871C30.4501 11.3871 30.2297 11.5566 30.1779 11.8038C30.1168 12.088 30.2982 12.3676 30.5825 12.4287V12.4297Z"
            fill="#FF83F3"
          />
          <path
            d="M31.174 9.03903C35.1523 9.89174 38.1928 13.3183 38.5687 17.3698C38.5956 17.6587 38.8474 17.8726 39.1418 17.8457C39.2816 17.8328 39.4085 17.7652 39.4992 17.6578C39.5881 17.5494 39.6316 17.4124 39.6187 17.2726C39.4122 15.033 38.5067 12.9582 37.0031 11.2759C35.5116 9.60565 33.5719 8.47611 31.3962 8.00856C31.3591 8.00115 31.3221 7.99652 31.286 7.99652C31.0434 7.99652 30.8231 8.16595 30.7712 8.41315C30.7083 8.69739 30.8907 8.977 31.1749 9.0381L31.174 9.03903Z"
            fill="#FF83F3"
          />
          <path
            d="M17.415 12.4295C17.6993 12.3684 17.8807 12.0869 17.8196 11.8027C17.7659 11.5555 17.5474 11.386 17.3049 11.386C17.2688 11.386 17.2317 11.3907 17.1947 11.3981C15.717 11.7147 14.4014 12.4813 13.3885 13.6146C12.3692 14.7561 11.7544 16.1644 11.6146 17.6855C11.6016 17.8253 11.6442 17.9624 11.734 18.0707C11.8229 18.179 11.9516 18.2466 12.0914 18.2586C12.3877 18.2855 12.6377 18.0707 12.6645 17.7827C12.9052 15.1811 14.8597 12.9794 17.415 12.4304V12.4295Z"
            fill="#FF83F3"
          />
          <path
            d="M16.8245 9.03916C17.1087 8.97805 17.2902 8.6966 17.2291 8.41236C17.1754 8.16516 16.9569 7.99573 16.7143 7.99573C16.6773 7.99573 16.6412 8.00036 16.6042 8.00776C14.4266 8.47532 12.4887 9.60486 10.9972 11.2751C9.49362 12.9583 8.58999 15.0322 8.38168 17.2718C8.36871 17.4116 8.4113 17.5487 8.50111 17.657C8.58999 17.7653 8.71869 17.8329 8.85849 17.8449C9.15291 17.8718 9.40474 17.657 9.43159 17.369C9.80656 13.3194 12.8471 9.89465 16.8245 9.04009V9.03916Z"
            fill="#FF83F3"
          />
          <path
            d="M35.6327 31.64H34.1927V35H32.3447V26.36H36.3647C38.0867 26.36 39.4247 27.098 39.4247 28.766C39.4247 29.966 38.7107 30.626 37.7927 30.848V30.968C38.7047 31.214 39.0347 31.736 39.1367 32.684L39.2387 33.608C39.2987 34.184 39.3827 34.49 39.6167 34.82V35H37.7207C37.5467 34.67 37.4627 34.364 37.4087 33.716L37.3547 33.008C37.2767 32.054 36.8627 31.64 35.6327 31.64ZM34.1927 27.71V30.284H36.1607C37.0487 30.284 37.6307 29.858 37.6307 29C37.6307 28.142 37.0487 27.71 36.1607 27.71H34.1927Z"
            fill="white"
          />
          <path
            d="M23.1084 35V34.82L26.2044 26.36H28.2384L31.3344 34.82V35H29.4924L28.8384 33.074H25.5864L24.9324 35H23.1084ZM26.0124 31.718H28.4124L27.2724 28.328H27.1524L26.0124 31.718Z"
            fill="white"
          />
          <path
            d="M16.0889 26.36H23.7569V27.728H20.8469V35H18.9989V27.728H16.0889V26.36Z"
            fill="white"
          />
          <path
            d="M8.64945 28.73C8.64945 27.368 9.78345 26.216 11.9914 26.216C14.1994 26.216 15.4174 27.32 15.5074 28.784V28.964H13.7734C13.7614 27.92 12.9934 27.512 12.0334 27.512C11.0614 27.512 10.4554 27.95 10.4554 28.634C10.4554 29.324 11.0014 29.618 11.9134 29.792L13.1374 30.032C14.7634 30.35 15.7534 31.04 15.7534 32.516C15.7534 33.998 14.6014 35.144 12.2614 35.144C9.92745 35.144 8.56545 33.998 8.48145 32.504V32.324H10.2334C10.3534 33.374 11.1574 33.848 12.2434 33.848C13.3414 33.848 13.9474 33.374 13.9474 32.642C13.9474 31.916 13.3834 31.64 12.3814 31.448L11.1574 31.208C9.59145 30.902 8.64945 30.062 8.64945 28.73Z"
            fill="white"
          />
          <path
            d="M35.6927 21.306V24H33.8447V15.36H35.6927V18.948H35.8127L39.2747 15.36H41.3927V15.54L37.7807 19.194L41.4647 23.82V24H39.3707L36.5687 20.418L35.6927 21.306Z"
            fill="white"
          />
          <path
            d="M24.6309 19.68C24.6309 16.986 26.2449 15.216 28.9029 15.216C31.5009 15.216 32.6289 16.824 32.7069 18.246V18.426H30.9609C30.9069 17.61 30.3909 16.602 28.9209 16.602C27.4089 16.602 26.4789 17.814 26.4789 19.68C26.4789 21.546 27.4089 22.752 28.9209 22.752C30.3849 22.752 30.9009 21.696 30.9969 20.856H32.7369V21.036C32.6049 22.458 31.5189 24.144 28.9029 24.144C26.2449 24.144 24.6309 22.374 24.6309 19.68Z"
            fill="white"
          />
          <path
            d="M15.0918 19.68C15.0918 16.95 16.7598 15.216 19.4358 15.216C22.1118 15.216 23.7798 16.95 23.7798 19.68C23.7798 22.41 22.1118 24.144 19.4358 24.144C16.7598 24.144 15.0918 22.41 15.0918 19.68ZM16.9398 19.68C16.9398 21.582 17.8758 22.752 19.4358 22.752C20.9958 22.752 21.9378 21.582 21.9378 19.68C21.9378 17.778 20.9958 16.602 19.4358 16.602C17.8758 16.602 16.9398 17.778 16.9398 19.68Z"
            fill="white"
          />
          <path
            d="M10.4609 20.64H9.02085V24H7.17285V15.36H11.1929C12.9149 15.36 14.2529 16.098 14.2529 17.766C14.2529 18.966 13.5389 19.626 12.6209 19.848V19.968C13.5329 20.214 13.8629 20.736 13.9649 21.684L14.0669 22.608C14.1269 23.184 14.2109 23.49 14.4449 23.82V24H12.5489C12.3749 23.67 12.2909 23.364 12.2369 22.716L12.1829 22.008C12.1049 21.054 11.6909 20.64 10.4609 20.64ZM9.02085 16.71V19.284H10.9889C11.8769 19.284 12.4589 18.858 12.4589 18C12.4589 17.142 11.8769 16.71 10.9889 16.71H9.02085Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8581_29753"
              x1="26.1045"
              y1="48"
              x2="25.7854"
              y2="-3.041e-06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EE8BFD" />
              <stop offset="1" stopColor="#795CFA" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default RockstarNFT;
